import React from "react";
import { View, StyleSheet, Image } from "react-native";
import routes from "../../navigation/routes";
import Logger from "../../common/utils/Logger";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtText from "../../components/NtText";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import colors from "../../config/colors";
import { navigationRef } from "../../../App";
import settings from "../../config/settings";
import AdminNavigator from "../../navigation/AdminNavigator";
import NtNavigationBar from "../../root/components/NtNavigationBar";
import BaseAdminController from "./BaseAdminController";

class AdminRootController extends BaseAdminController {
  state = {
    currentController: null,
    isMobile: false,
    sidebarCollapsed: this.context.user?.ui
      ? this.context.user?.ui?.sidebarcollapsed
      : true,
  };

  isPBXModuleEnabled = () => {
    return true;
  };

  options = [
    ...(this.isPBXModuleEnabled()
      ? [
          {
            icon: "deskphone",
            title: "PBX",
            isSelected: () => {
              let response = false;
              this.options
                ?.find((each) => each.title == "PBX")
                ?.items?.map((each) => {
                  response = response || each.isSelected();
                });

              return response;
            },
            items: [
              {
                icon: "lan-connect",
                iconSize: 18,
                title: "Registrations",
                titleStyle: { fontSize: 12, fontWeight: "500" },
                action: () => {
                  navigationRef.current.navigate(routes.registration);
                },
                isSelected: () => {
                  return (
                    navigationRef.current?.getCurrentRoute()?.name ==
                    routes.registration
                  );
                },
              },
            ],
          },
        ]
      : []),
  ];

  pbxItems = [];

  componentDidMount() {
    super.componentDidMount();
  }

  showSidePannel = () => {
    return true;
  };

  isPBXSelected = () => {
    let response = false;
    this.pbxItems.map((each) => {
      response = response || each.isSelected();
    });

    return response;
  };

  renderMenu = (item) => {
    const defaultIconSize = 22;

    if (item?.items) {
      return (
        <SubMenu
          key={item.title}
          icon={
            <NtMaterialIcon
              name={item.icon}
              color={colors.blue}
              size={item.iconSize || defaultIconSize}
            />
          }
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item.isSelected() ? colors.lighestGray : null,
          }}
          label={item.title}
        >
          {item?.items?.map((each) => this.renderMenu(each))}
        </SubMenu>
      );
    } else {
      return (
        <MenuItem
          key={item.title}
          icon={
            item.icon ? (
              <NtMaterialIcon
                name={item.icon}
                color={colors.blue}
                size={item.iconSize || defaultIconSize}
              />
            ) : null
          }
          onClick={() => {
            item.action();
          }}
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item?.isSelected() ? colors.lighestGray : null,
          }}
        >
          {item.title}
        </MenuItem>
      );
    }
  };

  render() {
    return (
      <View style={styles.container}>
        <View style={{ flex: 1, flexDirection: "row" }}>
          {this.showSidePannel() && (
            <Sidebar style={{}} collapsed={this.state.sidebarCollapsed}>
              <View style={{ height: "100%" }}>
                {/* header */}
                <View
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                    paddingTop: 10,
                  }}
                >
                  <Image
                    style={{ width: 35, height: 35, resizeMode: "contain" }}
                    source={require("../../assets/images/favicon-big-blue.png")}
                  />
                  {!this.state.sidebarCollapsed && (
                    <View style={{ marginLeft: 10 }}>
                      <NtText
                        style={{
                          fontSize: 15,
                          fontWeight: "800",
                          color: colors.almostBlack,
                        }}
                      >
                        Hi
                      </NtText>
                      <NtText
                        style={{
                          fontSize: 13,
                          fontWeight: "600",
                          color: colors.almostBlack,
                        }}
                      >
                        {this.context?.user?.username}
                      </NtText>
                    </View>
                  )}
                </View>

                <Menu style={{ marginTop: 50 }} closeOnClick={true}>
                  {this.options.map((each) => this.renderMenu(each))}
                </Menu>

                <View style={{ flex: 1 }} />

                <View style={{ paddingBottom: 30 }}>
                  <Menu>
                    <MenuItem
                      icon={<NtMaterialIcon name={"logout"} color={"red"} />}
                      onClick={() => {
                        if (this.context.user.authenticated) {
                          this.context.updateUser({
                            ...this.context.user,
                            authenticated: false,
                          });
                        }

                        setTimeout(() => {
                          navigationRef.current.navigate(routes.auth);
                        }, 500);
                      }}
                      style={{ ...styles.menu, color: "red" }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </View>
              </View>
            </Sidebar>
          )}

          <View style={{ flex: 1 }}>
            {this.showSidePannel() && <NtNavigationBar />}
            <AdminNavigator
              onControllerChanged={(controller) => {
                Logger("Current controller: ", controller);
                this.setState({ currentController: controller });
              }}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 0,
    flex: 1,
  },
  menu: {
    fontFamily: "Helvetica",
    color: colors.almostBlack,
    fontWeight: "600",
    fontSize: 13,
  },
});

export default AdminRootController;
